import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset window scroll on client-side route changes (footer → legal pages, etc.). */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
